import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import { isError, isSuccess, ResourcesItem } from 'redux-and-the-rest';

import { getOrFetchIsland, ISLAND_INCLUDES } from '../../redux/reducers/islandReducer';
import { ApplicationState } from '../../redux/types';
import { IslandModel } from '../../models/islandModel';
import LoadingIndicator from '../shared/LoadingIndicator';
import { Routes } from '../../routes';
import IslandWrap from './IslandWrap';

interface Props {
  island: ResourcesItem<IslandModel>;
}

/**
 * Container component that renders the Island.
 */
const IslandContainerView = ({ island }: Props): React.ReactElement => {
  if (isSuccess(island)) {
    const { values } = island;

    return (
      <IslandWrap island={values} />
    );
  }

  /**
   * This ensures a User reverts to their first Island available,
   * or recreates a new Island. They could have been passed a friend's Url for
   * whatever reason (403). Also clears up any cached Island Urls that have subsequently been deleted (404).
   */
  if (isError(island)) {
    return <Redirect to={Routes.Islands.Index} />;
  }

  return <LoadingIndicator />;
};

const mapStateToProps = (
  { islands }: ApplicationState,
  { match: { params: { id } } }: RouteComponentProps<{ id: string; }>,
) => ({
  island: getOrFetchIsland(islands, { id, include: ISLAND_INCLUDES }),
});

export default withRouter(connect(mapStateToProps)(IslandContainerView));
